import { IUserProps } from '@/entities/User'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IUserState {
  response: IResponseProps<IUserProps>
  current: IUserProps | null
  filter: string
  scrollTop: number
}

export const state = (): IUserState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  filter: 'all',
  scrollTop: 0
})

export default state
